import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonContent,
  IonImg,
  IonInput,
  IonItem,
  IonLabel,
  IonLoading,
  IonNote,
  IonPage,
  useIonToast,
} from '@ionic/react';
import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { AppContext } from '../../lib/context/AppContext';

const SignIn: React.FC = (props) => {
  const { login, apiService, appStorage, user } = useContext(AppContext);
  const [present] = useIonToast();
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ reValidateMode: 'onChange', mode: 'all' });

  useEffect(() => {
    if (!user) {
      appStorage?.clear();
    }
  }, [apiService]);

  return (
    <IonPage>
      <IonContent fullscreen>
        <a href='/' className='fixed top-16 left-8 z-10'>
          <IonImg src={'/assets/icon/icon.png'} className='w-8' />
        </a>
        <IonLoading spinner='bubbles' isOpen={loading} />
        <div className='h-screen flex items-center justify-center bg-app z-20'>
          <IonCard className='w-full max-w-md'>
            <IonCardHeader>
              <IonCardTitle>Accedi</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <form
                onSubmit={handleSubmit(async (data) => {
                  setLoading(true);
                  apiService?.post('/auth/local?populate=address', data).then(
                    async (response) => {
                      setLoading(false);
                      await login(response.data.user, response.data.jwt);
                    },
                    (error) => {
                      setLoading(false);
                      present({
                        message:
                          error.response?.data?.error?.message ||
                          error?.message ||
                          'Errore durante il login',
                        duration: 2500,
                        position: 'top',
                        color: 'danger',
                      });
                    }
                  );
                })}
              >
                <IonItem
                  fill='solid'
                  className={`${!errors.identifier && 'ion-valid'} 
                  ${!!errors.identifier && 'ion-invalid'} `}
                >
                  <IonLabel position='floating'>Email</IonLabel>
                  <IonInput
                    type='email'
                    {...register('identifier', { required: true })}
                    autocomplete='off'
                    aria-autocomplete='none'
                  ></IonInput>
                  <IonNote slot='error'>Email non valida</IonNote>
                </IonItem>

                <IonItem
                  fill='solid'
                  className={`mt-4 ${!errors.password && 'ion-valid'} 
                  ${!!errors.password && 'ion-invalid'} `}
                >
                  <IonLabel position='floating'>Password</IonLabel>
                  <IonInput
                    type='password'
                    {...register('password', { required: true })}
                  ></IonInput>
                  <IonNote slot='error'>Password obbligatoria</IonNote>
                </IonItem>

                <div className='mt-8 flex justify-between'>
                  <IonButton routerLink='forgot-password' fill='clear'>
                    Password dimenticata?
                  </IonButton>
                  <IonButton type='submit'>Accedi</IonButton>
                </div>
              </form>

              <div className='border-top w-full h-[1px] bg-gray-300 my-4 relative'>
                <span className='bg-white absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 p-2'>
                  Oppure
                </span>
              </div>
              <div className='mt-8'>
                <IonButton routerLink='sign-up' expand='block' fill='clear'>
                  Registrati
                </IonButton>
              </div>
            </IonCardContent>
          </IonCard>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default SignIn;
